/** Create a stable request key even in older browser and test environments. */
export function newOperationKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `branch-${Date.now()}-${Math.random().toString(36).slice(2)}`
}
